var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "msg-classify-manager-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            staticClass: "app-main-inner-row",
            staticStyle: { "padding-top": "10px" }
          },
          [
            _c(
              "div",
              { staticClass: "triggers" },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Search")))]),
                _c("el-input", {
                  staticStyle: { width: "200px", margin: "0 10px" },
                  attrs: { placeholder: _vm.$t("common.tips.fuzzySearch") },
                  on: {
                    input: function($event) {
                      return _vm.fastSearchHandle()
                    }
                  },
                  model: {
                    value: _vm.keyword,
                    callback: function($$v) {
                      _vm.keyword = $$v
                    },
                    expression: "keyword"
                  }
                }),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.btnAdd } },
                  [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.btnEdit } },
                  [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "danger" },
                    on: { click: _vm.btnRemoveHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            staticClass: "section grid-wrapper",
            staticStyle: { "flex-grow": "1" }
          },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%" },
              attrs: {
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData,
                "grid-options": _vm.gridOptions,
                "side-bar": _vm.sideBarDefs
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              attrs: {
                "config-module": "202405282007",
                total: _vm.pageInfo.total,
                page: _vm.pageInfo.pageNum,
                limit: _vm.pageInfo.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.pageInfo, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.pageInfo, "pageSize", $event)
                },
                pagination: _vm.loadData
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog",
          attrs: {
            slot: "reference",
            "close-on-click-modal": false,
            visible: _vm.showEditDialog,
            title: _vm.title,
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showEditDialog = $event
            },
            closed: _vm.cancelHandler
          },
          slot: "reference"
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "dialog-tabs",
              attrs: { "tab-position": "top" },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            _vm._l(_vm.form, function(item) {
              return _c(
                "el-tab-pane",
                { attrs: { label: item.name, name: item.name } },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "dialog-tabs-form",
                      attrs: { model: item, "label-width": "100px" }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.ClassifyName")
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "required-star",
                            staticStyle: { width: "200px" },
                            model: {
                              value: item.classifyName,
                              callback: function($$v) {
                                _vm.$set(item, "classifyName", $$v)
                              },
                              expression: "item.classifyName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SystemMaintenance.Sort") } },
                        [
                          _c("el-input-number", {
                            staticClass: "required-star",
                            attrs: {
                              disabled: item.language !== "zh_CN",
                              "controls-position": "right",
                              min: 1,
                              max: 999999999
                            },
                            on: {
                              change: function($event) {
                                return _vm.sortSyncHandle(item)
                              }
                            },
                            model: {
                              value: item.sort,
                              callback: function($$v) {
                                _vm.$set(item, "sort", $$v)
                              },
                              expression: "item.sort"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SystemMaintenance.Remark") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: { type: "textarea" },
                            model: {
                              value: item.remark,
                              callback: function($$v) {
                                _vm.$set(item, "remark", $$v)
                              },
                              expression: "item.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini ", type: "primary" },
                  on: { click: _vm.submitHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini " }, on: { click: _vm.cancelHandler } },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }